<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Match</label>
      </div>
      <select class="custom-select"
              disabled
              name="resultat_match">
        <option>
          {{ (equipe_a) ? equipe_a.nom.toUpperCase() : '' }} -
          {{ (equipe_b) ? equipe_b.nom.toUpperCase() : '' }}
          ({{
            (resultat) ? (new Date(resultat.date_rencontre).toLocaleDateString() + ' - ' + resultat.temps_rencontre) : ''
          }})
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe domiciliée</label>
      </div>
      <input class="form-control"
             :value="equipe_a ? equipe_a.nom.toUpperCase() : ''"
             disabled
             type="text">
    </div>
    <!--
        <div class="input-group-sm input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="resultat_equipe_a">Equipe domiciliée</label>
          </div>
          <select id="resultat_equipe_a"
                  v-model="dataForm.equipe_a_buteurs_id"
                  class="custom-select"
                  name="resultat_equipe_a">
            <option>Choisissez l'équipe domiciliée...</option>
          </select>
        </div>
    -->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Score équipe domiciliée</label>
      </div>
      <input v-model="dataForm.score_equipe_a"
             class="form-control"
             name="resultat_score_equipe_a"
             placeholder="Entrez le nombre de buts marqués par l'équipe domiciliée"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe visiteuse</label>
      </div>
      <input class="form-control"
             :value="equipe_b ? equipe_b.nom.toUpperCase() : ''"
             disabled
             type="text">
    </div>
    <!--
        <div class="input-group-sm input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="resultat_equipe_b">Equipe visiteuse</label>
          </div>
          <select id="resultat_equipe_b"
                  v-model="dataForm.equipe_b_buteurs_id"
                  class="custom-select"
                  name="resultat_equipe_b">
            <option>Choisissez une équipe visiteuse...</option>
          </select>
        </div>
    -->
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Score équipe visiteuse</label>
      </div>
      <input v-model="dataForm.score_equipe_b"
             class="form-control"
             name="resultat_score_equipe_b"
             placeholder="Entrez le nombre de buts marqués par l'équipe domiciliée"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date et Temps de rencontre</label>
        <label class="input-group-text"></label>
      </div>
      <input :value="(resultat) ? resultat.date_rencontre : ''"
             disabled
             class="form-control"
             name="match_date_rencontre"
             type="date">
      <input :value="(resultat) ? resultat.temps_rencontre : ''"
             disabled
             class="form-control"
             name="match_temps_rencontre"
             type="time">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Terrain</label>
      </div>
      <select class="custom-select"
              disabled
              name="match_terrain">
        <option>{{ (terrain) ? terrain.nom : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Arbitre Principal</label>
      </div>
      <select class="custom-select"
              disabled
              name="match_arbitre_principal">
        <option>
          {{ (arbitre_principal) ?
            (
                arbitre_principal.prenom.charAt(0).toUpperCase() + arbitre_principal.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.postnom.charAt(0).toUpperCase() + arbitre_principal.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.nom.charAt(0).toUpperCase() + arbitre_principal.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Assistant 1</label>
      </div>
      <select disabled
              class="custom-select"
              name="match_arbitre_assistant_1">
        <option>
          {{ (arbitre_assistant_1) ?
            (
                arbitre_assistant_1.prenom.charAt(0).toUpperCase() + arbitre_assistant_1.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_1.postnom.charAt(0).toUpperCase() + arbitre_assistant_1.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_1.nom.charAt(0).toUpperCase() + arbitre_assistant_1.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Assistant 2</label>
      </div>
      <select disabled
              class="custom-select"
              name="match_arbitre_assistant_2">
        <option>
          {{ (arbitre_assistant_2) ?
            (
                arbitre_assistant_2.prenom.charAt(0).toUpperCase() + arbitre_assistant_2.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_2.postnom.charAt(0).toUpperCase() + arbitre_assistant_2.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_assistant_2.nom.charAt(0).toUpperCase() + arbitre_assistant_2.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Commissaire</label>
      </div>
      <select disabled
              class="custom-select"
              name="match_arbitre_commissaire">
        <option>
          {{ (arbitre_commissaire) ?
            (
                arbitre_commissaire.prenom.charAt(0).toUpperCase() + arbitre_commissaire.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_commissaire.postnom.charAt(0).toUpperCase() + arbitre_commissaire.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_commissaire.nom.charAt(0).toUpperCase() + arbitre_commissaire.nom.slice(1).toLowerCase()
            ) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Saison</label>
      </div>
      <select disabled
              class="custom-select"
              name="match_saison">
        <option>
          {{ (saison) ? (saison.annee_debut + ' - ' +
            saison.annee_fin): '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Championnat</label>
      </div>
      <select disabled
              class="custom-select"
              name="match_championnat">
        <option>
          {{ (championnat) ? championnat.nom : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Phase</label>
      </div>
      <select disabled
              class="custom-select"
              name="match_phase">
        <option value="aller">{{ (resultat) ? resultat.phase : '' }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Journée</label>
      </div>
      <input class="form-control"
             disabled
             :value="(resultat) ? resultat.journee : ''"
             name="match_journee"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    resultat: {
      type: Object
    }
  },
  data() {
    return {
      //
      matchs: null,
      equipes: null,
      terrains: null,
      arbitres: null,
      saisons: null,
      championnats: null,
      //
      equipe_a: null,
      equipe_b: null,
      terrain: null,
      arbitre_principal: null,
      arbitre_assistant_1: null,
      arbitre_assistant_2: null,
      arbitre_commissaire: null,
      saison: null,
      championnat: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        match_id: '',
        equipe_a_id: '',
        equipe_b_id: '',
        date_rencontre: '',
        temps_rencontre: '',
        terrain_id: '',
        arbitre_principal_id: '',
        arbitre_assistant_1_id: '',
        arbitre_assistant_2_id: '',
        arbitre_commissaire_id: '',
        score_equipe_a: '',
        score_equipe_b: '',
        saison_id: '',
        championnat_id: '',
        phase: '',
        journee: '',
        table: 'matchs_joues',
        table_id: this.resultat.match_joue_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
    ]),
    setMatchParams(resultat) {
      this.equipe_a = this.equipes.filter( (equipe) => equipe.equipe_id === resultat.equipe_a_id )[0]
      this.equipe_b = this.equipes.filter( (equipe) => equipe.equipe_id === resultat.equipe_b_id )[0]
      this.terrain = this.terrains.filter( (terrain) => terrain.terrain_id === resultat.terrain_id )[0]
      this.arbitre_principal = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === resultat.arbitre_principal_id )[0]
      this.arbitre_assistant_1 = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === resultat.arbitre_assistant_1_id )[0]
      this.arbitre_assistant_2 = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === resultat.arbitre_assistant_2_id )[0]
      this.arbitre_commissaire = this.arbitres.filter( (arbitre) => arbitre.arbitre_id === resultat.arbitre_commissaire_id )[0]
      this.saison = this.saisons.filter( (saison) => saison.saison_id === resultat.saison_id )[0]
      this.championnat = this.championnats.filter( (championnat) => championnat.championnat_id === resultat.championnat_id )[0]
    },
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Résultat modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification du résultat !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification du résultat !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.match_id === '')
        this.dataForm.match_id = this.resultat.match_id
      if(this.dataForm.equipe_a_id === '')
        this.dataForm.equipe_a_id = this.resultat.equipe_a_id
      if(this.dataForm.equipe_b_id === '')
        this.dataForm.equipe_b_id = this.resultat.equipe_b_id
      if(this.dataForm.date_rencontre === '')
        this.dataForm.date_rencontre = this.resultat.date_rencontre
      if(this.dataForm.temps_rencontre === '')
        this.dataForm.temps_rencontre = this.resultat.temps_rencontre
      if(this.dataForm.terrain_id === '')
        this.dataForm.terrain_id = this.resultat.terrain_id
      if(this.dataForm.arbitre_principal_id === '')
        this.dataForm.arbitre_principal_id = this.resultat.arbitre_principal_id
      if(this.dataForm.arbitre_assistant_1_id === '')
        this.dataForm.arbitre_assistant_1_id = this.resultat.arbitre_assistant_1_id
      if(this.dataForm.arbitre_assistant_2_id === '')
        this.dataForm.arbitre_assistant_2_id = this.resultat.arbitre_assistant_2_id
      if(this.dataForm.arbitre_commissaire_id === '')
        this.dataForm.arbitre_commissaire_id = this.resultat.arbitre_commissaire_id
      if(this.dataForm.score_equipe_a === '')
        this.dataForm.score_equipe_a = this.resultat.score_equipe_a
      if(this.dataForm.score_equipe_b === '')
        this.dataForm.score_equipe_b = this.resultat.score_equipe_b
      if(this.dataForm.saison_id === '')
        this.dataForm.saison_id = this.resultat.saison_id
      if(this.dataForm.championnat_id === '')
        this.dataForm.championnat_id = this.resultat.championnat_id
      if(this.dataForm.phase === '')
        this.dataForm.phase = this.resultat.phase
      if(this.dataForm.journee === '')
        this.dataForm.journee = this.resultat.journee
    },
    setDefaultValues() {
      const resultat = Object.assign({}, this.resultat);
      this.dataForm.match_id = resultat.match_id
      this.dataForm.equipe_a_id = resultat.equipe_a_id
      this.dataForm.equipe_b_id = resultat.equipe_b_id
      this.dataForm.date_rencontre = resultat.date_rencontre
      this.dataForm.temps_rencontre = resultat.temps_rencontre
      this.dataForm.terrain_id = resultat.terrain_id
      this.dataForm.arbitre_principal_id = resultat.arbitre_principal_id
      this.dataForm.arbitre_assistant_1_id = resultat.arbitre_assistant_1_id
      this.dataForm.arbitre_assistant_2_id = resultat.arbitre_assistant_2_id
      this.dataForm.arbitre_commissaire_id = resultat.arbitre_commissaire_id
      this.dataForm.score_equipe_a = resultat.score_equipe_a
      this.dataForm.score_equipe_b = resultat.score_equipe_b
      this.dataForm.saison_id = resultat.saison_id
      this.dataForm.championnat_id = resultat.championnat_id
      this.dataForm.phase = resultat.phase
      this.dataForm.journee = resultat.journee
      this.setMatchParams(resultat)
    }
},
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //matchs non joués
    this.axiosGetAllData({
      table: 'matchs_non_joues'
    })
        .then((data) => {
          this.matchs = data.data
          //equipes
          this.axiosGetAllData({
            table: 'equipes'
          })
              .then((data) => {
                this.equipes = data.data
                //terrains
                this.axiosGetAllData({
                  table: 'terrains'
                })
                    .then((data) => {
                      this.terrains = data.data
                      //arbitres
                      this.axiosGetAllData({
                        table: 'arbitres'
                      })
                          .then((data) => {
                            this.arbitres = data.data
                            //saisons
                            this.axiosGetAllData({
                              table: 'saisons'
                            })
                                .then((data) => {
                                  this.saisons = data.data
                                  //championnats
                                  this.axiosGetAllData({
                                    table: 'championnats'
                                  })
                                      .then((data) => {
                                        this.championnats = data.data
                                        this.setDefaultValues()
                                      })
                                      .catch((data) => {
                                        this.championnats = data
                                      })
                                })
                                .catch((data) => {
                                  this.saisons = data
                                })
                          })
                          .catch((data) => {
                            this.arbitres = data
                          })
                    })
                    .catch((data) => {
                      this.terrains = data
                    })
              })
              .catch((data) => {
                this.equipes = data
              })

        })
        .catch((data) => {
          this.matchs = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/components/Update.vue